import React from "react";
import { useState } from "react";
import { useRef } from "react";
import GUI_Header from "./gui/GUI_Header";
import GUI_Credit from "./gui/GUI_Credit";
import GUI_InputTextSingleLeft from "./gui/GUI_InputTextSingleLeft";
import GUI_InputTextArea_withClearClick from "./gui/GUI_InputTextArea_withClearClick";
import Knapsack_Result from "./components/Knapsack_Result";
import { useEffect } from "react";

//https://www.pluralsight.com/guides/how-to-pass-data-between-react-components

const Knapsack = () => {
	const pageTitle = "Knapsack - Combinatorial Optimization";
	const title = "Knapsack";
	const desc =
		"Combinatorial Optimization: Given a set of items, each with a size and a value, determine the number of each item to include in a collection so that the total size is less than or equal to a given limit and the total value is as large as possible.";

	useEffect(() => {
		document.title = pageTitle;
	}, []);
	const [guiTxt1, guiTxtChange1] = useState(15); //bag size
	const [guiTxtArea, guiTxtAreaChange] = useState(
		"A,1,5\nB,4,10\nC,2,2\nD,1,2\nE,1,1\nF,3,9\nG,2,4\nH,4,7\nI,3,5\nJ,5,15"
	);
	// const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const childRef = useRef(null); //Result component at bottom
	//---------------------------------------------
	var itemList = [];
	var bestSet; //best Basket
	var matrix; //Basket[][]//memory for processing
	var txt_result; //processing time

	//Main Function
	const buttonClick1 = () => {
		process();
		//clear
		itemList = [];
		bestSet = null;
		matrix = null;
		txt_result = null;
	};

	function process() {
		//Generate Data from GUI -----------------------
		var arr = guiTxtArea.split("\n");
		// console.log("Lines: " + arr.length);
		const new_itemList = [];
		for (var i = 0; i < arr.length; i++) {
			var dd = arr[i].split(",");
			if (dd.length >= 3) {
				new_itemList.push({
					id: i,
					name: dd[0],
					weight: parseInt(dd[1]),
					value: parseInt(dd[2]),
					chosen: false,
				});
			}
		}
		itemList = new_itemList;
		//
		console.log("# of item: " + new_itemList.length);
		console.log("bag size: " + guiTxt1);
		//Process knapsack --------------------
		bestSet = knapsack(new_itemList, guiTxt1);
		doUpdateChosen(bestSet);
		//prepare text for result -------------
		var t = "";
		for (var a = bestSet.items.length - 1; a >= 0; a--) {
			if (t != "") {
				t += ",";
			}
			t += bestSet.items[a].name;
		}
		txt_result += "\r\nItems: " + t;
		txt_result += "\r\nSize: " + bestSet.w;
		txt_result += "\r\nValue: " + bestSet.v;
		//
		console.log("Optimal List: " + t);
		console.log("Optimal Value: " + bestSet.v);
		//--------------------------
		callChild_createResult(itemList, txt_result);
	}

	//set "chosen" in itemList
	const doUpdateChosen = (bestSet) => {
		for (var i = 0; i < itemList.length; i++) {
			itemList[i].chosen = false;
			for (var j = 0; j < bestSet.items.length; j++) {
				// console.log("check " + itemList[i].name + " vs " + bestSet.items[j].name);
				if (itemList[i].id == bestSet.items[j].id) {
					// console.log("select " + itemList[i].name);
					itemList[i].chosen = true;
					break;
				}
			}
		}
	};
	//--------------------------------------------------------------------------------------
	//SIMPLER VER, no details printed -------------------------------------------
	// //0-1 Knapsack Problem (Dynamic Programming)
	// // knapsack(itemAll, bag) {//row, col
	// const knapsack = (itemAll, bag) => {
	//   //from oth language
	// 	// matrix = new int[itemAll.length + 1][bag + 1];
	//   // for(a = 0; a < map.length;a++) {Arrays.fill(map[a],-99);}
	//   //-----------------------
	//   //https://www.codegrepper.com/code-examples/javascript/2d+array+js
	//   matrix = new Array(itemAll.length + 1).fill(-99).map(() => new Array(bag + 1).fill(-99));
	// 	var result = putItem(itemAll.length, bag);

	//   // System.out.println("Max Value: " + result);
	// 	// //------------
	// 	// long end_time = System.nanoTime();
	// 	// double difference = (end_time - start_time) / 1e6;
	// 	// System.out.println("end " + difference + " ms");
	//   return result;
	// }

	// //n is number of item; in each call, we consider the last item (n-1)
	// const putItem = (n, c) => {
	// 	if(matrix[n][c] > 0) {return matrix[n][c];}//already have data
	// 	var v = 0;
	// 	if(n == 0 || c == 0) { v = 0; } //no item left OR  capacity out
	// 	else if(listItem[n-1].weight > c) { //item is too big
	// 		v = putItem(n - 1, c); //skip this item, check next item
	// 	}
	// 	else {//this item can be added
	// 		var temp1 = putItem(n - 1, c);//if not put this item
	// 		var temp2 = listItem[n - 1].value + putItem(n - 1, c - listItem[n - 1].weight);//if put this item
	// 		v = Math.max(temp1, temp2);
	// 	}
	// 	matrix[n][c] = v;
	//   // console.log("value =  " + v);
	// 	return v;
	// }

	//----------------------------------------------------------------------
	const knapsack = (itemAll, bagsize) => {
		var startTime = performance.now();
		//https://www.codegrepper.com/code-examples/javascript/2d+array+js
		matrix = new Array(itemAll.length + 1)
			.fill(null)
			.map(() => new Array(bagsize + 1).fill(null)); //generate matrix as "Memory" for processing

		var best = putItem(itemAll.length, bagsize); //optimal set
		//-----------------------
		var endTime = performance.now();
		txt_result = `Processing time ${endTime - startTime} ms`;
		console.log(txt_result);
		// console.log("Optimal List: " + JSON.stringify(best.items));
		// console.log("Optimal Value: " + best.v);
		return best;
	};

	//output is BASKET >> { items: [], v: 0 };
	//n is number of item; in each call, we consider the last item (n-1)
	//c is capacity or size
	const putItem = (n, c) => {
		// console.log("AAA");
		if (matrix[n][c] != null) {
			//already have data
			return matrix[n][c];
		}
		// console.log("BBB");
		var basket = { items: [], v: 0, w: 0 }; //OUTPUT initialized
		if (n == 0 || c == 0) {
			//no item left OR capacity out
			// basket.v = 0;
		} else if (itemList[n - 1].weight > c) {
			//item is too big, skip this item
			basket = putItem(n - 1, c);
		} else {
			//this item can be added
			var temp1 = putItem(n - 1, c); //if not put this item
			var temp2 = putItem(n - 1, c - itemList[n - 1].weight); //if put this item
			var v0 = itemList[n - 1].value;
			var w0 = itemList[n - 1].weight;
			if (temp1.v > temp2.v + v0) {
				basket.v += temp1.v;
				basket.w += temp1.w;
				basket.items.push(...temp1.items);
			} else {
				basket.v += temp2.v + v0;
				basket.w += temp2.w + w0;
				basket.items.push(itemList[n - 1]);
				basket.items.push(...temp2.items);
			}
		}
		// console.log("TTT: " + basket);
		matrix[n][c] = basket; //ERROR Here
		return basket;
	};

	//----------------------------------------------------
	const callChild_createResult = (bestSet, txt_result) => {
		childRef.current.createResult_optimal(bestSet, txt_result, guiTxt1);
	};

	//https://namespaceit.com/blog/how-to-call-child-method-from-parent-in-react-functional-component

	return (
		<div className="todoapp stack-large">
			<GUI_Header title={title} desc={desc} />
			<div style={{ marginTop: "3em" }}> </div>
			<GUI_InputTextSingleLeft
				valueChange={guiTxtChange1}
				value={guiTxt1}
				label="Box Size:"
			/>
			<div style={{ marginTop: "2em" }}> </div>
			<GUI_InputTextArea_withClearClick
				guiTxtArea={guiTxtArea}
				guiTxtAreaChange={guiTxtAreaChange}
				buttonClick={buttonClick1}
				placeholder={"name,size,value"}
				label1={"Item Lists"}
				label2={"name,size,value"}
			/>
			<div style={{ marginTop: "3em" }}> </div>
			<Knapsack_Result ref={childRef} />
			<GUI_Credit />
		</div>
	);
};

export default Knapsack;
